import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=5e5e6012&scoped=true&"
import script from "./OrganizationMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMenu.vue?vue&type=style&index=0&id=5e5e6012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e6012",
  null
  
)

export default component.exports